<template>
  <div data-view="daily-reports">
    <layout-logged-frame :title="$t('cpc_reports')" has-before>
      <template v-slot:header-actions>
        <header-actions :actions="headerActions" />
      </template>

      <template v-slot:before>
        <NavigationTabs :tabs="navigationTabs"/>
      </template>

      <template v-slot:content>
        <div class="form-wrapper">
          <ReportFilters
            :title="$t('cpc_reports')"
            is-advanced
            @filter="onFilter"
            @clearFilters="onClearFilters"
          >
            <template v-slot:phone-actions>
              <sort-by-select
                :columns="advancedReportsColumns"
                :pagination="phoneSort"
                :on-update-pagination="onPhoneSortChange"
                :sync-to-url="false"
              />
            </template>
          </ReportFilters>

          <table-base-client-sort
            has-phone-layout
            :phone-sort="phoneSort"
            :columns="advancedReportsColumns"
            :items="advancedReports"
            :is-loading="isLoadingAdvancedReports"
            :no-data-title="$t('no_reports')"
            :no-data-subtitle="$t('start_to_use_our_products')"
            has-custom-items-template
          >
            <template v-slot:item-cell="scope">
              <template v-if="scope.cell.column.value === 'external_link'">
                <div
                  v-if="!scope.cell.item.external_link"
                  class="link-box-empty"
                >
                  -
                </div>
                <div v-else class="link-box">
                  <v-btn
                    variant="text"
                    @click="
                      (event) => openUrl(event, scope.cell.item.external_link)
                    "
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-else-if="scope.cell.column.value === 'source_url'">
                <div class="link-box">
                  <v-btn
                    variant="text"
                    @click="
                      (event) => openUrl(event, scope.cell.item.source_url)
                    "
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-else-if="scope.cell.column.value === 'rate'">
                {{ `${scope.cell.item.rate} ${scope.cell.item.currency.symbol}` }}
              </template>

              <template v-else-if="scope.cell.column.value === 'commission'">
                {{ `${scope.cell.item.commission} ${scope.cell.item.currency.symbol}` }}
              </template>

              <template v-else>
                {{
                  displayColumnValue(scope.cell.item, scope.cell.column.value)
                }}
              </template>
            </template>
          </table-base-client-sort>
        </div>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import navigationTabs from '../../config/reports/navigationTabs';
  import NavigationTabs from '../../components/NavigationTabs'
  import ReportFilters from '../../components/forms/filters/Reports';
  import advancedReportsColumns from '../../config/reports/advancedReportsColumns';
  import {
    isObj,
    isArr,
    extractNestedProp,
    openUrlInNewWindow,
  } from '../../utils';

  export default {
    components: {
      NavigationTabs,
      ReportFilters,
    },
    data() {
      return {
        phoneSort: {},
        advancedReportsColumns,
        navigationTabs,
        advancedReportsPagination: {
          totalItems: 0,
        },
        advancedReportsQuery: {},
        isLoadingAdvancedReports: false,
        isDownloadingAdvancedReport: false,
      };
    },
    computed: {
      headerActions() {
        return [
          {
            key: 'download',
            icon: 'arrow_downward',
            title: `${this.$t('download')} .csv`,
            isDisabled: !this.hasAdvancedReports,
            isLoading: this.isDownloadingAdvancedReport,
            onClick: this.downloadAdvancedReport,
          },
        ];
      },
      advancedReports() {
        return this.$store.getters['reports/advancedDaily'].items;
      },
      hasAdvancedReports() {
        const { advancedReports } = this;
        return isArr(advancedReports) && advancedReports.length > 0;
      },
    },
    methods: {
      onPhoneSortChange({ sortBy, order }) {
        this.phoneSort = { sortBy, order };
      },
      getAdvancedReports({ contract = -1, date_range = '' } = {}) {
        this.isLoadingAdvancedReports = true;
        const query = {
          contract,
          date_range,
        };

        return this.$store
          .dispatch('reports/getDailyAdvanced', query)
          .then((res) => {
            this.advancedReportsQuery = query;
            this.advancedReportsPagination.totalItems = res.items.length;
            this.isLoadingAdvancedReports = false;

            return res;
          })
          .catch((err) => {
            this.isLoadingAdvancedReports = false;
            return err;
          });
      },
      getSearchQuery({ contract, dates }) {
        const query = {};

        query.contract = isObj(contract) ? contract.id : -1;
        query.date_range = dates;

        return query;
      },
      onFilter(filters) {
        this.advancedReportsQuery = {
          ...this.advancedReportsQuery,
          page: 1,
          ...this.getSearchQuery(filters),
        };

        this.getAdvancedReports(this.advancedReportsQuery);
      },
      onClearFilters(filters) {
        this.onFilter(filters);
      },
      downloadAdvancedReport() {
        const { contract, date_range } = this.advancedReportsQuery;
        const query = {
          contract,
          date_range,
        };

        this.isDownloadingAdvancedReport = true;
        return this.$store
          .dispatch('reports/downloadDailyAdvanced', query)
          .finally(() => {
            this.isDownloadingAdvancedReport = false;
          });
      },
      openUrl(event, url) {
        event.preventDefault();
        event.stopPropagation();
        return openUrlInNewWindow(window.open(), url);
      },
      displayColumnValue(item, columnValue) {
        return extractNestedProp(item, columnValue);
      },
    },
  };
</script>
